// API and Backend URLs
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

// Service Areas Data
export const SERVICE_AREAS = {
  melbourne_cbd: { name: "Melbourne CBD", fee: 0 },
  inner_suburbs: { name: "Inner Suburbs (< 10km)", fee: 0 },
  middle_suburbs: { name: "Middle Suburbs (10-20km)", fee: 15 },
  outer_suburbs: { name: "Outer Suburbs (20-35km)", fee: 30 },
  regional: { name: "Regional (35-50km)", fee: 50 }
};

// Features data for "Why Choose Us"
export const FEATURES = [
  { icon: "MapPin", title: "We Come To You", desc: "Mobile service at your home or work" },
  { icon: "Shield", title: "Fully Insured", desc: "Complete peace of mind" },
  { icon: "Award", title: "Premium Products", desc: "Only the best for your vehicle" },
  { icon: "Star", title: "5-Star Service", desc: "Consistently top-rated" }
];

// Booking time slots
export const TIME_SLOTS = [
  "8:00 AM", "8:30 AM", "9:00 AM", "9:30 AM", "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM",
  "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM", "2:30 PM",
  "3:00 PM", "3:30 PM", "4:00 PM", "4:30 PM", "5:00 PM", "5:30 PM",
  "6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM", "8:00 PM"
];

// Admin time slots
export const ADMIN_TIMES = [
  "8:00 AM", "8:30 AM", "9:00 AM", "9:30 AM", "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM",
  "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM", "2:30 PM",
  "3:00 PM", "3:30 PM", "4:00 PM", "4:30 PM", "5:00 PM", "5:30 PM",
  "6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM", "8:00 PM"
];

// Status colors for admin dashboard
export const getStatusColor = (status) => {
  switch (status) {
    case 'pending_deposit': return 'bg-yellow-500/20 text-yellow-400';
    case 'deposit_paid': return 'bg-green-500/20 text-green-400';
    case 'confirmed': return 'bg-cyan-500/20 text-cyan-400';
    case 'in_progress': return 'bg-purple-500/20 text-purple-400';
    case 'completed': return 'bg-emerald-500/20 text-emerald-400';
    case 'cancelled': return 'bg-red-500/20 text-red-400';
    default: return 'bg-slate-500/20 text-slate-400';
  }
};

// Format status for display
export const formatStatus = (status) => {
  switch (status) {
    case 'pending_deposit': return 'Pending Deposit';
    case 'deposit_paid': return 'Deposit Paid';
    case 'confirmed': return 'Confirmed';
    case 'in_progress': return 'In Progress';
    case 'completed': return 'Completed';
    case 'cancelled': return 'Cancelled';
    default: return status;
  }
};

// Policy sections
export const POLICY_SECTIONS = [
  {
    id: "overview",
    title: "Service Overview",
    content: `RainXpress provides professional mobile car detailing services across Melbourne. Our trained technicians bring all equipment and supplies directly to your location, whether it's your home, workplace, or any other convenient spot.`
  },
  {
    id: "booking",
    title: "Booking & Deposits",
    content: `A $20 non-refundable booking deposit is required to secure your appointment. This deposit is deducted from your final service cost. The remaining balance is due upon completion of the service.`
  },
  {
    id: "cancellation",
    title: "Cancellation Policy",
    content: `Cancellations made more than 24 hours before your appointment will receive a full deposit refund. Cancellations within 24 hours forfeit the deposit. No-shows are charged the full deposit amount.`
  },
  {
    id: "reschedule",
    title: "Rescheduling",
    content: `You may reschedule your appointment free of charge up to 24 hours before the scheduled time. Rescheduling within 24 hours may be subject to availability and a $10 rescheduling fee.`
  },
  {
    id: "weather",
    title: "Weather Policy",
    content: `In cases of severe weather (heavy rain, storms, extreme heat above 40°C), we may need to reschedule your appointment. We will contact you as soon as possible to arrange an alternative time at no extra cost.`
  },
  {
    id: "pricing",
    title: "Pricing & Add-ons",
    content: `All prices are based on standard vehicle conditions. Heavily soiled vehicles, excessive pet hair, or other challenging conditions may incur additional charges. We will inform you of any additional costs before beginning work.`
  },
  {
    id: "photos",
    title: "Photo Consent",
    content: `By booking our services, you consent to our technicians taking before and after photos for quality assurance purposes. Photos may be used on our website, social media, or marketing materials. Please let us know if you prefer your vehicle not be photographed.`
  },
  {
    id: "personal_items",
    title: "Personal Items",
    content: `Please remove all personal items and valuables from your vehicle before the service. While our technicians take utmost care, RainXpress is not responsible for any items left in the vehicle during detailing.`
  },
  {
    id: "damage",
    title: "Pre-existing Damage",
    content: `Our technicians will note any pre-existing damage before commencing work. If you are aware of any existing damage (scratches, dents, paint issues), please inform us beforehand. RainXpress is not liable for pre-existing conditions.`
  }
];

// Suburb data for travel fee estimation
export const SUBURBS_DATA = {
  melbourne_cbd: ["Melbourne", "CBD", "Southbank", "Docklands", "West Melbourne", "East Melbourne", "Carlton", "Parkville", "North Melbourne"],
  inner_suburbs: ["South Yarra", "Richmond", "Collingwood", "Fitzroy", "Brunswick", "Northcote", "Prahran", "St Kilda", "Port Melbourne", "Albert Park", "Middle Park", "South Melbourne", "Abbotsford", "Cremorne", "Clifton Hill", "Fairfield", "Thornbury", "Preston", "Coburg", "Footscray", "Seddon", "Yarraville"],
  middle_suburbs: ["Hawthorn", "Kew", "Camberwell", "Malvern", "Caulfield", "Glen Iris", "Carnegie", "Murrumbeena", "Bentleigh", "Brighton", "Sandringham", "Hampton", "Moorabbin", "Cheltenham", "Mentone", "Elwood", "Elsternwick", "Balaclava", "Windsor", "Armadale", "Toorak", "Kooyong", "Glen Waverley", "Mount Waverley", "Burwood", "Box Hill", "Blackburn", "Doncaster", "Templestowe", "Bulleen", "Ivanhoe", "Heidelberg", "Rosanna", "Reservoir", "Fawkner", "Pascoe Vale", "Essendon", "Moonee Ponds", "Ascot Vale", "Maribyrnong", "Sunshine", "Braybrook", "Maidstone", "Altona", "Williamstown", "Newport"],
  outer_suburbs: ["Clayton", "Springvale", "Noble Park", "Dandenong", "Keysborough", "Frankston", "Carrum", "Chelsea", "Mordialloc", "Parkdale", "Aspendale", "Edithvale", "Patterson Lakes", "Bonbeach", "Seaford", "Dingley Village", "Rowville", "Ferntree Gully", "Boronia", "Bayswater", "Croydon", "Ringwood", "Mitcham", "Vermont", "Forest Hill", "Wantirna", "Knox", "Scoresby", "Mulgrave", "Wheelers Hill", "Brandon Park", "Oakleigh", "Hughesdale", "Huntingdale", "Monash", "Notting Hill", "Chadstone", "Ashwood", "Jordanville", "Bundoora", "Mill Park", "South Morang", "Lalor", "Epping", "Thomastown", "Campbellfield", "Broadmeadows", "Gladstone Park", "Tullamarine", "Airport West", "Niddrie", "Keilor", "Deer Park", "Caroline Springs", "Taylors Lakes", "Sydenham", "Watergardens", "St Albans", "Ardeer", "Laverton", "Hoppers Crossing", "Werribee", "Point Cook", "Truganina", "Tarneit"]
};
